import {reportToBugsnag} from '../../../srcCommon/services/bugsnag/bugsnag';
import {ApiMessageDataGroup} from '../../models/api/dataGroupModel';
import {ThunkAction} from '../../store/appThunk';
import {fetchApiAsync} from '../http/http';
import {findMessageQueue} from './specializedTaskQueues';

export function pushMessageUpdatedTask(messageUid: string, messageUrl: string): ThunkAction {
  return async (dispatch, getState) => {
    // Wait for our turn to work.
    const queue = findMessageQueue(dispatch, getState, messageUid);
    await queue.waitForTurnAsync();

    try {
      // Fetch the full message.
      const serverDataGroup = await fetchApiAsync(ApiMessageDataGroup, messageUrl);

      // We must use the conversation queue if this data group contains conversations.
      if (serverDataGroup.conversations && serverDataGroup.conversations.length) {
        reportToBugsnag(new Error('Unexpected conversation in fetch after message_updated'));
      }

      // Notify the queue.
      return queue.provideResultAsync(serverDataGroup);
    } catch (error) {
      queue.reportError();
      throw error;
    }
  };
}
